import {
  searchAndFiltersFilterClickParams,
  searchAndFiltersShowAllClickParams,
  searchAndFiltersStartedParams,
} from '@wix/bi-logger-media-data/v2/types';
import { FilterName } from '../../../../constants/FilterName';
import { MediaManagerSDKAnyItem } from '../../../media-manager-sdk';

export interface IUseSearchAndFiltersAnalyticsHandlers {
  trackSearchAndFiltersStarted(params?: searchAndFiltersStartedParams): void;
  trackSearchAndFiltersShowAllClick(params?: searchAndFiltersShowAllClickParams): void;
  trackSearchAndFiltersFilterClick(params?: searchAndFiltersFilterClickParams): void;
  trackSearchAndFiltersSubscribeToLoadFinish(
    itemsLoadPromise: Promise<MediaManagerSDKAnyItem[]>,
    pathname: string,
  ): void;
  trackSearchAndFiltersClear(clickOrigin: ClickOriginsSearchAndFiltersClear): void;
}

export enum ClickOriginsSearchAndFiltersClear {
  Search = 'clear_search',
  AllResults = 'all_results',
}

export enum ErrorTypes {
  CanceledByUser = 'canceled_by_user',
  NoResults = 'no_results',
  Technical = 'technical',
}

export enum ClickOrigins {
  Search = 'search',
  FilterCategories = 'filter_categories',
  FilterColor = 'filter_color',
  FilterMediaType = 'filter_media_type',
  FilterOrientation = 'filter_orientation',
  SearchFromRelated = 'search_from_related',
  Breadcrumbs = 'breadcrumbs',
  QuickSearch = 'quick_search',
}

export enum Targets {
  MediaType = 'media_type',
  All = 'all',
}

export enum Tabnames {
  ImportFromWix = 'import_from_wix',
}

export const FiltersBiClickOrigins = {
  [FilterName.Type]: 'filter_type',
  [FilterName.Category]: 'filter_category',
  [FilterName.Orientation]: 'filter_orientation',
  [FilterName.Color]: 'filter_color',
  [FilterName.Pricing]: 'filter_pricing',
};

export enum SearchAndFiltersShowAllTargets {
  Everywhere = 'everywhere',
  AllResults = 'all_results',
}
